// SC-4b — a signed-in PDF is fetched through the session, never opened by raw
// address: a new tab carries no Authorization header, so the server answers
// {"detail":"Not authenticated"}. The app's axios interceptor attaches the
// token, so we fetch the bytes and hand the tab a same-origin blob: URL.
import axios from 'axios';
import { toast } from 'sonner';

export async function openPdf(apiPath, filename, { download = false, type = 'application/pdf' } = {}) {
  // Opened synchronously, before the await, or the popup blocker eats it.
  const win = download ? null : window.open('', '_blank');
  try {
    const res = await axios.get(apiPath, { responseType: 'blob' });
    const url = URL.createObjectURL(new Blob([res.data], { type }));
    if (download || !win) {
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } else {
      win.location = url;
    }
    setTimeout(() => URL.revokeObjectURL(url), 60000);
    return true;
  } catch (e) {
    if (win) win.close();
    toast.error('The PDF could not be made — try again');
    return false;
  }
}

export default openPdf;
